<template>
    <div>
        <RichText
            :text="block.Text"
            :cols="Number(block.TextColumns ?? 1)"
        />

        <div
            v-if="block?.Buttons?.length"
            class="mt-6 flex flex-wrap items-center gap-2"
            :class="{
                'justify-center': block.ButtonAlignment === 'centred',
            }"
        >
            <NuxtLink
                v-for="(button, index) in block.Buttons"
                :key="index"
                :href="button.url"
                :target="button.target"
                :title="button.title"
            >
                <DButton
                    :left-icon="button?.iconPosition === 'left' ? iconName(button?.icon) : null"
                    :theme="buttonTheme(button.buttonStyle)"
                    size="lg"
                    :right-icon="button?.iconPosition === 'right' ? iconName(button?.icon) : null"
                >
                    {{ button.text }}
                </DButton>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    const { buttonTheme } = useButtonTheme()

    const { iconName } = useIcons()

    defineProps({
        id: String,
        block: Object,
    })
</script>

<style scoped>
    @reference 'tailwindcss';
    @reference '@digistorm/spark/dist/variables.css';

    .prose {
        --tw-prose-headings: var(--text-neutral-base);
    }
    :deep(.prose :is(p, h1, h2, h3, h4, h5, h6)[style*='text-align:center']) {
        @apply mx-auto max-w-[780px];
    }
</style>
